module.exports = __webpack_public_path__ + "static/img/13.dd3b9e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/13.png
// module id = vvbM
// module chunks = 0